export class FullScreenMode {
  constructor(
    public PhysicalAddress: string,
    public Handler: string,
    public IsFullscreen: boolean,
    public RefreshRateMiliseconds: number,
    public Width?: number,
    public Height?: number
  ) {}
}
